/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimeDatatableParams } from '../../models/prime-datatable-params';
import { SystemSettingViewModelPrimeDatatableResults } from '../../models/system-setting-view-model-prime-datatable-results';

export interface List$Params {
      body?: PrimeDatatableParams
}

export function List(http: HttpClient, rootUrl: string, params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemSettingViewModelPrimeDatatableResults>> {
  const rb = new RequestBuilder(rootUrl, List.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemSettingViewModelPrimeDatatableResults>;
    })
  );
}

List.PATH = '/api/SystemSettings/List';
